export function ErrorScreen({ error, resetError }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white px-6">
      <div className="max-w-md space-y-4 text-center">
        <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Something went wrong</p>
        <h1 className="text-2xl font-semibold">We hit a snag</h1>
        <p className="text-sm text-slate-300">
          The app ran into an error. We’ve logged the details so we can fix it quickly.
        </p>
        {error?.message && (
          <p className="rounded-lg bg-white/10 px-4 py-2 text-xs text-left text-slate-200 break-words">
            {error.message}
          </p>
        )}
        <div className="flex items-center justify-center gap-3">
          <button
            className="rounded-full bg-white text-slate-950 px-4 py-2 text-sm font-semibold"
            onClick={() => window.location.reload()}
            type="button"
          >
            Reload
          </button>
          <button
            className="rounded-full border border-white/30 px-4 py-2 text-sm"
            onClick={() => resetError?.()}
            type="button"
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  );
}
